/**
 * HomePage — landing page with mode selection.
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';

const HomePage = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center flex-1 px-4 py-10">
      {/* Logo / Title */}
      <div className="mb-8 text-center">
        <h1 className="text-5xl sm:text-6xl font-extrabold tracking-wider mb-2">
          <span className="text-correct">OS</span> Wordle
        </h1>
        <p className="text-gray-500 dark:text-gray-400 text-lg">
          Türkçe Kelime Oyunu
        </p>
      </div>

      {/* Sample Grid Decoration */}
      <div className="flex gap-1.5 mb-10">
        {['W', 'O', 'R', 'D', 'S'].map((letter, i) => {
          const colors = [
            'bg-correct',
            'bg-present',
            'bg-absent dark:bg-absent-dark',
            'bg-correct',
            'bg-present',
          ];
          return (
            <div
              key={i}
              className={`w-12 h-12 sm:w-14 sm:h-14 ${colors[i]} text-white flex items-center justify-center text-xl font-bold rounded`}
            >
              {letter}
            </div>
          );
        })}
      </div>

      {/* Mode Selection */}
      <div className="flex flex-col gap-4 w-full max-w-xs">
        <button
          onClick={() => navigate('/classic')}
          className="w-full py-4 rounded-xl bg-correct text-white font-bold text-lg hover:opacity-90 transition-opacity shadow-lg"
        >
          🎯 Klasik Mod
        </button>

        <button
          onClick={() => navigate('/custom')}
          className="w-full py-4 rounded-xl bg-present text-white font-bold text-lg hover:opacity-90 transition-opacity shadow-lg"
        >
          🔗 Özel Kelime
        </button>
      </div>

      {/* How to Play */}
      <div className="mt-10 max-w-sm text-center">
        <h3 className="font-bold text-lg mb-3">Nasıl Oynanır?</h3>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2 text-left">
          <p>• 5 harfli Türkçe kelimeyi 6 denemede bul.</p>
          <p>
            • <span className="inline-block w-4 h-4 bg-correct rounded-sm align-middle mr-1"></span>
            <strong>Doğru:</strong> Harf doğru yerde.
          </p>
          <p>
            • <span className="inline-block w-4 h-4 bg-present rounded-sm align-middle mr-1"></span>
            <strong>Var:</strong> Harf var ama yanlış yerde.
          </p>
          <p>
            • <span className="inline-block w-4 h-4 bg-absent rounded-sm align-middle mr-1"></span>
            <strong>Yok:</strong> Harf kelimede yok.
          </p>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
